import Flickity from 'flickity';
import 'flickity-imagesloaded';

/**
 * Helper method for creating and setting up Flickity instances
 *
 * @param {string} sel - DOMString to match
 * @param {object} opts - Flickity options
 * @param {function} cb - Optional callback method with flickity instance as its parameter
 * @param {boolean} resizeOnLoad - Whether flickity instance should resize on Window load
 */
window.newFlickity = function(sel, opts, cb, resizeOnLoad = false) {
  const el = document.querySelector(sel);

  if (el) {
    const flkty = new Flickity(
      el,
      Object.assign(
        {
          cellAlign: 'left',
          prevNextButtons: false,
          arrowShape:
            'M0 39.9 78.7 0 78.7 17.2 15.6 47.9 78.7 78.7 78.7 95.9 0 56 0 39.9z',
        },
        opts
      )
    );

    if (resizeOnLoad) {
      window.addEventListener('load', flkty.resize);
    }
    if (cb) cb(flkty);
  }
};
